var index = {
  AJAX_TIMEOUT: 10000,
  SHIELD_ENDPOINTS: {
    V1CONTENT: 'ogateway/public/v1/content'
  },
  MANIFEST_KEY: 'targeted-content.manifest',
  SITES: {
    CREDIT_CARDS: {
      TARGETED_CONTENT: {
        KEY: 'targeted-content.credit-cards',
        MANIFEST_KEY: 'targeted-content.credit-cards.manifest'
      }
    }
  },
  PAGE_NOT_FOUND_RESPONSE: 'Cache value is empty/null',
  PREVIEW_PAGE_PATH: '/targeted-content/preview/',
  // Squeezebox content on overview page
  SQUEEZEBOX_DEFAULT_CONFIG: {
    id: 'targetedContentContainer',
    title: '',
    titleHeadingTag: 'h2',
    options: {
      color: 'gray'
    },
    oneAtATime: true,
    adaCaption: 'Squeezebox of targeted masthead container content',
    panels: []
  },
  SQUEEZEBOX_DEFAULT_PANEL_CONFIG: {
    label: '',
    innerPanels: {
      title: '',
      id: '',
      titleHeadingTag: 'h3',
      color: 'gray',
      oneAtATime: true
    },
    content: []
  }
};

export { index as default };
